module.exports = __webpack_public_path__ + "static/thomas-and-veronica.c3e5d50f.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/avatars/thomas-and-veronica.jpg
// module id = 285
// module chunks = 168707334958949